/* global window */
// wrappers for session storage apis

const getItem = (key) => {
	try {
		return window.sessionStorage.getItem(key);
	} catch(e) {
		return null;
	}
};

const setItem = (key, value) => {
	try {
		return window.sessionStorage.setItem(key, value);
	} catch(e) {
		return null;
	}
};

module.exports = {
	getItem,
	setItem,
};